function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.51 9.674l-7.502-6.819a1.494 1.494 0 00-2.018 0L3.491 9.674A1.503 1.503 0 003 10.784v8.634c-.004.377.13.742.376 1.027a1.49 1.49 0 001.124.507h4.497a.75.75 0 00.75-.75v-4.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v4.5a.75.75 0 00.75.75h4.505c.246.003.49-.057.706-.174A1.507 1.507 0 0021 19.452v-8.668a1.504 1.504 0 00-.49-1.11z",
    fill: props.fill
  }));
}

export default SvgHouse;